/**
 * Global Accordion System
 * Handles accordion functionality for the entire theme
 */

(function() {
  'use strict';
  
  // Initialize all accordions on the page
  function initAccordions() {
    const accordions = document.querySelectorAll('[data-accordion]');
    
    accordions.forEach(accordion => {
      const toggle = accordion.querySelector('[data-accordion-toggle]');
      const content = accordion.querySelector('[data-accordion-content]');
      
      if (!toggle || !content) return;
      
      // Set initial state
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        accordion.setAttribute('data-accordion-open', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
      
      // Add click handler
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        
        const currentlyOpen = accordion.getAttribute('data-accordion-open') === 'true';
        
        // Toggle this accordion
        if (currentlyOpen) {
          // Close
          accordion.setAttribute('data-accordion-open', 'false');
          toggle.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
          content.style.maxHeight = '0';
        } else {
          // Open
          accordion.setAttribute('data-accordion-open', 'true');
          toggle.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
  
  // Re-initialize for dynamically added content (like AJAX)
  window.initAccordions = initAccordions;
})();
